import { Button } from "@fp/ui/components/base/buttons/button";
import { PageContentContainer } from "@fp/ui/components/base/page-layout/page-layout";
import { useRouter } from "@tanstack/react-router";
import { SearchLg } from "@untitledui/icons";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";

export function RouteNotFound() {
	const router = useRouter();

	return (
		<AdminLayout>
			<AdminPageHeader
				title="Page not found"
				parent={{ url: "/dashboard", label: "Home" }}
			/>
			<PageContentContainer className="items-center justify-center gap-4 text-center">
				<SearchLg className="size-6 text-fg-quaternary" />
				<p className="text-md text-tertiary">
					We couldn't find that page. It may have moved or the link may be
					incorrect.
				</p>
				<Button
					color="primary-neutral"
					onClick={() => {
						router.navigate({ to: "/dashboard" });
					}}
				>
					Go to home
				</Button>
			</PageContentContainer>
		</AdminLayout>
	);
}
